export default __webpack_public_path__ + "static/media/glodny-light.e548c606.svg";